import { HeaderSimple } from "@/playground/components/DevHome/table/pages/conversation_center/components/HeaderSimple";
import { Button, Tooltip, TooltipContent, TooltipTrigger } from "@aircall/ds";
import { Info } from "@aircall/react-icons";
import { useTranslation } from "react-i18next";

export function SentimentHeader() {
  const { t } = useTranslation();
  return (
    <div
      className="flex items-center gap-2"
      data-test="sentiment-column-header"
    >
      <HeaderSimple label="mood" />
      <Tooltip>
        <TooltipTrigger
          type="button"
          aria-label={t("mood")}
          className="inline-flex text-muted-foreground"
        >
          <Info className="size-4" />
        </TooltipTrigger>
        <TooltipContent>
          {t("customer_mood.tooltip.content")}{" "}
          <Button
            variant="link"
            className="h-auto p-0"
            render={
              <a
                href={t("customer_mood.tooltip.href_url")}
                target="_blank"
                rel="noreferrer"
              />
            }
          >
            {t("customer_mood.tooltip.href_title")}
          </Button>
        </TooltipContent>
      </Tooltip>
    </div>
  );
}
